module.exports = __webpack_public_path__ + "img/101.78014edd.png";